import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { theme as antdTheme } from 'antd';

import App from './App';
import { store } from './store';
import './index.css';
// 初始化多语言（i18n）
import './i18n';
import AntdLocaleProvider from './i18n/AntdLocaleProvider';

// 现代 SaaS 设计令牌（与管理端共用同一套）
const FONT_FAMILY =
  "'Inter', -apple-system, 'PingFang SC', 'Microsoft YaHei', sans-serif";

const fastStarTheme = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: '#2F6BFF',
    colorInfo: '#2F6BFF',
    colorSuccess: '#16A34A',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorLink: '#2F6BFF',
    borderRadius: 10,
    fontFamily: FONT_FAMILY,
    colorBgLayout: '#F7F8FA',
    colorBgContainer: '#FFFFFF',
    colorBorder: '#EAECF0',
    colorBorderSecondary: '#EAECF0',
    colorText: '#1A1F2E',
    colorTextSecondary: '#6B7280',
    colorTextTertiary: '#6B7280',
    fontSize: 14,
    controlHeight: 36,
    boxShadow:
      '0 1px 3px rgba(16,24,40,.06), 0 1px 2px rgba(16,24,40,.04)',
    boxShadowSecondary:
      '0 1px 3px rgba(16,24,40,.06), 0 1px 2px rgba(16,24,40,.04)',
  },
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 36,
      fontWeight: 500,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Card: {
      borderRadiusLG: 12,
      boxShadowTertiary:
        '0 1px 3px rgba(16,24,40,.06), 0 1px 2px rgba(16,24,40,.04)',
    },
    Menu: {
      itemSelectedBg: '#EAF0FF',
      itemSelectedColor: '#2F6BFF',
      itemActiveBg: '#EAF0FF',
      itemHoverBg: '#F2F4F7',
      itemBorderRadius: 8,
      itemMarginInline: 8,
      iconSize: 16,
    },
    Input: { borderRadius: 10, controlHeight: 36 },
    Select: { borderRadius: 10, controlHeight: 36 },
    Table: {
      headerBg: '#F7F8FA',
      headerColor: '#6B7280',
      borderColor: '#EAECF0',
      headerSplitColor: '#EAECF0',
    },
    Tag: { borderRadiusSM: 6 },
    Layout: {
      bodyBg: '#F7F8FA',
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
    },
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AntdLocaleProvider theme={fastStarTheme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AntdLocaleProvider>
    </Provider>
  </React.StrictMode>
); 